module.exports = __webpack_public_path__ + "img/closed-eyes.045c6162.png";